<template>
  <div :class="$style.type_outer">
    <span v-if="!this.value.length && !editable">--</span>
    <div :class="$style.group_tag" v-for="(value, key) in valueGroup" :key="key">
      <div class="fs12 lh20">{{ value.label }} </div>
      <div v-for="child in value.types" :key="child.value" class="fs14 lh18">{{ child.label }}</div>
    </div>
    <el-popover
      v-if="editable"
      placement="right-start"
      v-model="visible"
    >
      <div :class="$style.MaxHeight">
        <div :class="$style.box_title">将内容标记为：</div>
        <div v-if="options.length" class="smallScrollbar p5 pl20 pr20">
          <div v-for="group in options" :key="group.value"
            :class="$style.add__item"
          >
            <div :class="[
              $style.group_label,
              selectedParents.includes(group.value) ? $style.active : ''
            ]">{{ group.label}}</div>
            <div :class="$style.group_box">
              <span
                v-for="item in group.types"
                :key="item.value"
                :class="[
                  $style.item_label,
                  selected.includes(item.value) ? $style.active : ''
                ]"
                @click="onChange(item)"
              >
                {{ item.label }}
              </span>
            </div>
          </div>
          <el-button size="small" :class="$style.btn" @click="onSure">确定</el-button>
        </div>
        <div v-else>{{ emptyText }}</div>
      </div>
      <div slot="reference" :class="$style.add__icon" ref="add">
        <i  class="el-icon-edit-outline" @click="onOpen"></i>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    form: Object,
    data: Object,
    editable: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: '暂无数据'
    },
  },
  inject: ['detail'],
  data () {
    return {
      visible: false,
      selected: [],
    }
  },
  computed: {
    optionsMap() {
      //生成optionsMap
      return this.options.reduce((map, item, index) => {
        // 为了保证顺序
        let parentValue = 'parent' + index
        map[parentValue] = item
        if (item.types) {
          item.types.forEach(child => {
            map[child.value] = {
              ...child,
              parent: item.value,
              parentValue
            }
          })
        }
        return map
      }, {})
    },
    valueGroup() {
      let valueObject = this.value.reduce((map, item) => {
        let curInfo = this.optionsMap[item]
        let parentValue = curInfo.parentValue
        if (parentValue && map[parentValue]) {
          map[parentValue].types.push(curInfo)
        } else {
          map[parentValue] = {
            label: this.optionsMap[curInfo.parentValue].label,
            value: parent,
            types: [curInfo]
          }
        }
        return map
      }, {})
      return Object.keys(valueObject).sort().map(key => valueObject[key])
    },
    selectedParents() {
      // 不需要去重
      return this.selected.map(item => this.optionsMap[item]?.parent)
    }
  },
  methods: {
    onOpen() {
      this.selected = [...this.value]
    },
    onChange(item) {
      let index = this.selected.indexOf(item.value)
      if (index === -1) {
        this.selected.push(item.value)
      } else {
        this.selected.splice(index, 1)
      }
    },
    onSure() {
      this.$emit('input', this.selected)
      this.visible = false
    }
    
  }
}
</script>

<style lang="scss" module>
.type_outer {
  display: flex;
  align-items: flex-start;
}
.add__icon {
  cursor: pointer;
  color: #000;
  font-size: 20px;
}
.MaxHeight {
  width: 360px;
  max-height: 450px;
  overflow: auto;
}
.box_title {
  font-size: 15px;
  color: #000;
}

.group_label {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.group_box {
  color: #ababab;
  text-align: justify;
  margin: 2px 0 10px;
}

.item_label {
  font-size: 12px;
  line-height: 22px;
  cursor: pointer;
  &:hover {
    color: #333;
  }
  &::after {
    content: '|';
    margin: 0 5px;
    color: #ababab;
  }
}

.active {
    color: #bd3124!important;
  }
.item_label:last-child::after {
  display: none;
}

.btn {
  padding: 5px 20px;
  float: right;
}

.group_tag {
  padding: 3px 10px;
  color: #fff;
  background-color: #f00;
  font-size: 13px;
  line-height: 16px;
  margin-right: 10px;
  border-radius: 3px;
  margin-bottom: 2px;
  text-align: center;
}

</style>